const months = [
	'jan',
	'feb',
	'mar',
	'apr',
	'may',
	'jun',
	'jul',
	'aug',
	'sep',
	'oct',
	'nov',
	'dec',
]

export default ({ date, format, seperator = '/' }) => {
	const splitedDate = date?.split(seperator)
	const splitedFormat = format?.split(seperator)
	let d,
		m,
		y = ''

	for (let i = 0; i < splitedDate?.length; ++i) {
		if (splitedFormat[i]?.includes('d')) {
			d = splitedDate[i]
		} else if (splitedFormat[i]?.includes('m')) {
			m = splitedDate[i]
		} else if (splitedFormat[i]?.includes('M')) {
			months.forEach((val, index) => {
				const month = splitedDate[i]?.substring(0, 3)?.toLowerCase()
				if (val === month) {
					index < 9 ? (m = `0${index + 1}`) : (m = `${index + 1}`)
				}
			})
		} else if (splitedFormat[i]?.includes('y')) {
			y = splitedDate[i]
		}
	}
	return `${m}/${d}/${y}`
}
